import Emitter from "./Emitter";

export default class BalanceChange extends Emitter {
    constructor(gb) {
        super(gb);
    }

    SPINGAMES_handler(data) {
        if (data && typeof data !== "object") {
            this.emitTop({ event: "round_result", balance: data });
            this.emitParent({ event: "round_result", balance: data });
        }
    }

    EXCITE_handler(balance) {
        this.emitParent({ event: "setBalance", payload: { balance: balance }});
    }

    PLAYTECH_handler(balance) {
        if (this.gb.ptResFeat && this.gb.ptResFeat.includes('balanceupdate')) {
            let obj = {
                _type: "ucip.balanceupdate.g2wBalanceUpdateNotification",
                balance: {
                    value: typeof balance === "number" ? balance/100 : balance,
                    winAmount: 0,
                }
            }

            if (this.gb.settings.nativeMobileApp) {
                obj.handled = true;
                window.parent.postMessage(JSON.stringify(obj));

            } else {
                this.emitParent(JSON.stringify(obj));
            }
        }
    }

    LNWOGS_handler(balance) {
        if (balance < 0) return;

        let preSpinBalanceDeduction = false,
            b = JSON.parse(this.gb.settings.walletExtraInfoOnAuthenticate);

        if (this.gb.balanceVersion && this.gb.balanceVersion % 1 !== 0) {
            preSpinBalanceDeduction = true; // this is only for Bragg games, that send balance version xxx.5 on preSpin (to set UI correctly
        }

        let realBalance = Math.round((balance / 100) * 100) / 100,
            bonusBalance = b.bonusBalance ?? 0;

        if (this.gb.wallet?.tmpBalance) {
            bonusBalance = this.gb.wallet.tmpBalance.bonusBalance ?? 0;
        }

        if (preSpinBalanceDeduction && bonusBalance > 0) {
            bonusBalance = Math.round((bonusBalance - (this.gb.betAmount / 100)) * 100) / 100;
        }

        if (bonusBalance < 0) {
            // the spin where he ran out of bonus money, so some goes from bonus and some from realBalance

            // TODO: not totally sure if ok to add betAmount back to realBalance ... if not ok, revisit this logic ... LOOKS LIKE THIS IS NOT NEEDED ... REMOVE AFTER CONFIRMATION BY OPERATOR
            // realBalance = (balance + this.gb.betAmount) / 100;

            this.gb.wallet.balanceChange(realBalance + bonusBalance, 0);
        } else {

            let rb = Math.round((realBalance - bonusBalance) * 100) / 100;
            // console.log("drek GAME MSG", balance, rb, bonusBalance);
            this.gb.wallet.balanceChange(rb, bonusBalance);
            // this.gb.wallet.balanceChange(1, bonusBalance);
        }
    }

    _default(balance) {
        if(balance && balance.payload) {
            this.gb.balance = balance.payload.balance;
        } else {
            this.gb.balance = balance;
        }

        this.emitTop({ wpgaction: "balance", param: { balance: balance } });
        this.emitParent({ wpgaction: "balance.parent", param: { balance: balance } });
        this.emitiOS({ wpgaction: "balance", param: { balance: balance } });

        this.emitTop({ eventName: "balanceUpdated", param: { balance: balance } });
        this.emitParent({ eventName: "balanceUpdated.parent", param: { balance: balance } });
        this.emitiOS({ eventName: "balanceUpdated", param: { balance: balance } });
    }
}
